import { School } from '../../../components/school/school';
import Layout from '../../../layouts/layout';
import { toTitleCase } from '../../../utils';
import type { School as SchoolType } from '../../../types';

type SchoolDetailPageProps = {
  school: SchoolType;
};

export default function SchoolDetailPage(props: SchoolDetailPageProps) {
  const { school } = props;

  return (
    <Layout title={toTitleCase(school.name)}>
      <School school={school} />
    </Layout>
  );
}
